import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spin } from "@arco-design/web-react";

import { routes } from "../../routes/routes";
import { RootState } from "../../store/store";
import { IntakeFlow } from "./IntakeFlow";

export const IntakeRouteGuard = () => {
  const configLoaded = useSelector((state: RootState) => state.config.configLoaded);
  const aiMatchingPreview = useSelector((state: RootState) => state.config.aiMatchingPreview);

  if (!configLoaded) {
    return <Spin style={{ margin: "120px auto" }} size={32} />;
  }

  if (!aiMatchingPreview) {
    return <Navigate to={routes.DASHBOARD} replace />;
  }

  return <IntakeFlow />;
};
